import mobileTest from "is-mobile";
import "../css/category.scss";
import "./components/addreadmore";
import "./components/landingpage";

import "./modules/amazzingfilter/front.js";


$('#products').on("mouseover", ".product-thumbnail:not(.mobile)", function (e) {
    e.preventDefault();

    let id_product_container = $(this).data('idproduct');
    console.log('id_product_container', id_product_container);

    let attributesListEl = $(this).find('.attributesList');
    attributesListEl.addClass('active');

    // REMOVE ALL BACKIMGACTIVE CLASS
    $(".thumbnail-container").find('img').removeClass('backimgactive');

    // ADD BACKIMGACTIVE CLASS ON HOVER IMAGE
    let imgEl = $(this).find('img');
    if (imgEl.hasClass('backimgactive') === false) {

        let currentFrontSrc = imgEl.prop('currentSrc');
        if (!currentFrontSrc || currentFrontSrc == '') {
            console.log('failed src .. return');
            return;
        }

        // OK FOR CONTINUE
        imgEl.addClass('backimgactive');



        imgEl.attr('data-savecurrentfrontsrc', currentFrontSrc);
        console.log('currentFrontSrc', currentFrontSrc);

        let backimgproductsrc = imgEl.attr('data-backimgproductsrc');

        // CHANGE SOURCES IMAGE
        imgEl.closest('picture').find('source').attr('srcset', backimgproductsrc);

        // CHANGE SRC IMAGE
        imgEl.attr('src', backimgproductsrc);
        console.log('backimgproduct src mouseover', backimgproductsrc);
    }



}).on("mouseout", function (e) {
    e.preventDefault();

    let attributesListEl = $(this).find('.attributesList');
    attributesListEl.removeClass('active');

    let imgEl = $(document).find('.backimgactive');

    imgEl.closest('picture').find('source').attr('srcset', imgEl.attr('data-savecurrentfrontsrc'));

    imgEl.attr('src', imgEl.attr('data-savecurrentfrontsrc'));
    imgEl.removeClass('backimgactive');
});

$(document).on("scroll", function () {
    const isMobile = mobileTest();
    if (isMobile === false && $(window).scrollTop() >= 100) {
        import(
            /* webpackChunkName: "btntotop" */
            "./components/btntotop.js"
        ).then((btntotopImport) => {
            btntotopImport.btntotop();
        });
    }
});
